import { useContext } from 'react';

import { RoleEnum } from '_lib/api/apiTypes.shim';
import { AuthContext } from '_lib/featureComponents/auth/authContext';
import { AccountAdmin, AccountUser, CallCenterUser, SystemUser } from '_lib/featureComponents/auth/permissionHelpers';

export const useAuthRoles = () => {
  const { authUserCacheResource } = useContext(AuthContext);

  const cachedAuthUserQuery = authUserCacheResource.useCacheQuery();
  const user = cachedAuthUserQuery.data;

  return {
    isCallCenterUser: user?.role === RoleEnum.USER && CallCenterUser({ user }),
    isAccountAdmin: !!user && AccountAdmin({ user }),
    isAccountUser: !!user && user.role === RoleEnum.USER && AccountUser({ user }),
    isSystem: !!user && SystemUser({ user })
  };
};

export type AuthRoles = ReturnType<typeof useAuthRoles>;
